/* Imports */

import React, { useLayoutEffect } from "react";
import am5themes_Animated from "@amcharts/amcharts5/themes/Animated";
import * as am5 from "@amcharts/amcharts5";
import * as am5xy from "@amcharts/amcharts5/xy";
import * as am5plugins_exporting from "@amcharts/amcharts5/plugins/exporting";
import am5locales_fa_IR from "../../../../Assets/lang/fa_IR";
import moment from "moment-jalaali";
import Loader from "../../../../Loader";

function DailyChart({ data, dateHOC, loading }) {
  // console.log(data, "is data");
  useLayoutEffect(() => {
    let root = am5.Root.new("DailyChart");

    // Set themes
    // https://www.amcharts.com/docs/v5/concepts/themes/
    root.setThemes([am5themes_Animated.new(root)]);
    root.locale = am5locales_fa_IR;
    // Create chart
    // https://www.amcharts.com/docs/v5/charts/xy-chart/
    let chart = root.container.children.push(
      am5xy.XYChart.new(root, {
        layout: root.verticalLayout,
        focusable: true,
        panX: true,
        panY: true,
        wheelX: "panX",
        wheelY: "zoomX",
        pinchZoomX: true,
      })
    );

    let exporting = am5plugins_exporting.Exporting.new(root, {
      menu: am5plugins_exporting.ExportingMenu.new(root, {
        align: "right",
        valign: "bottom",
        items: [
          {
            type: "format",
            format: "jpg",
            label: "Export image",
          },
          {
            type: "format",
            format: "pdfdata",
            label: "Export JSON",
          },
          {
            type: "separator",
          },
          {
            type: "format",
            format: "print",
            label: "Print",
          },
        ],
      }),
    });

    let easing = am5.ease.linear;
    chart.get("colors").set("step", 3);

    let firstDate = new Date(
      moment(new Date(dateHOC[0])).format("jYYYY-jMM-jDDTHH:mm:ss")
    );
    firstDate.setHours(0);
    firstDate.setMinutes(0);
    firstDate.setSeconds(0);
    let newdate = new Date(
      moment(new Date(dateHOC[1])).format("jYYYY-jMM-jDDTHH:mm:ss")
    );
    newdate.setMinutes(59);
    newdate.setSeconds(59);
    newdate.setHours(23);
    const minDate = new Date(
      Date.UTC(
        firstDate.getUTCFullYear(),
        firstDate.getUTCMonth(),
        firstDate.getUTCDate(),
        firstDate.getUTCHours(),
        firstDate.getUTCMinutes(),
        firstDate.getUTCSeconds()
      )
    );
    const maxDate = new Date(
      Date.UTC(
        newdate.getUTCFullYear(),
        newdate.getUTCMonth(),
        newdate.getUTCDate(),
        newdate.getUTCHours(),
        newdate.getUTCMinutes(),
        newdate.getUTCSeconds()
      )
    );

    // Create axes
    // https://www.amcharts.com/docs/v5/charts/xy-chart/axes/
    let xAxis = chart.xAxes.push(
      am5xy.DateAxis.new(root, {
        maxDeviation: 0.1,
        groupData: false,
        baseInterval: {
          timeUnit: "second",
          count: 60,
        },
        renderer: am5xy.AxisRendererX.new(root, {}),
        tooltip: am5.Tooltip.new(root, {}),
        min: minDate.getTime(),
        max: maxDate.getTime(),
        strictMinMax: true,
      })
    );

    // Add cursor
    // https://www.amcharts.com/docs/v5/charts/xy-chart/cursor/
    let cursor = chart.set(
      "cursor",
      am5xy.XYCursor.new(root, {
        xAxis: xAxis,
        behavior: "none",
      })
    );
    cursor.lineY.set("visible", false);

    const series_list = [];

    function createAxisAndSeries(startValue, opposite, type, unit, name) {
      // console.log(startValue, opposite, type, unit, name)
      let yRenderer = am5xy.AxisRendererY.new(root, {
        opposite: opposite,
      });
      let yAxis = chart.yAxes.push(
        am5xy.ValueAxis.new(root, {
          maxDeviation: 0.2,
          renderer: yRenderer,
          min: type==="Pline"?0:0,
        })
      );

      if (chart.yAxes.indexOf(yAxis) > 0) {
        yAxis.set("syncWithAxis", chart.yAxes.getIndex(0));
      }

      // Add series
      // https://www.amcharts.com/docs/v5/charts/xy-chart/series/
      let series = chart.series.push(
        am5xy.LineSeries.new(root, {
          name: name,
          xAxis: xAxis,
          yAxis: type !== "Iline" ? chart.yAxes.getIndex(0) : yAxis,
          valueYField: "value",
          valueXField: "date",
          tooltip: am5.Tooltip.new(root, {
            pointerOrientation: "horizontal",
            labelText: "{valueY} " + unit,
          }),
          legendLabelText: "{name}",
          legendRangeLabelText: "{name}",
          locationX: 0,
          minDistance: type === "Iline" ? 2 : 4,
          connect: true,
          marginBottom: 10,
        
        })
      );
      series_list.push(series);

      series.strokes.template.setAll({ strokeWidth: 1 });

      yRenderer.grid.template.set("strokeOpacity", 0.05);
      yRenderer.labels.template.set("fill", series.get("fill"));
      yRenderer.setAll({
        stroke: series.get("fill"),
        strokeOpacity: 1,
        opacity: 1,
      });

      if (type === "Pline") {
        series.strokes.template.setAll({
          strokeWidth: 1.5,
        });
        series.fills.template.setAll({
          fillOpacity: 0.5,
          visible: true,
        });
      } else if (type === "Iline" || type === "Vline") {
        series.strokes.template.setAll({
          strokeWidth: 0.5,
          
          // strokeDasharray: [10, 5],
        });
      }

      // Set up data processor to parse string dates
      // https://www.amcharts.com/docs/v5/concepts/data/#Pre_processing_data
      // series.data.processor = am5.DataProcessor.new(root, {
      //   dateFormat: "yyyy-MM-ddTHH:mm:ss",
      //   dateFields: ["date"],
      // });
      // console.log(generateChartData(startValue, type) , "is generated chart data" , type)
      series.data.setAll(generateChartData(startValue, type));
    }

    // add scrollbar
    chart.set(
      "scrollbarX",
      am5.Scrollbar.new(root, {
        orientation: "horizontal",
      })
    );
      // console.log(data)
    let rev_data = data?.reverse();
    createAxisAndSeries(
      rev_data,
      false,
      "Pline",
      "W",
      "HVDC Bus Power - توان باس HVDC"
    );
    createAxisAndSeries(
      rev_data,
      true,
      "Vline",
      "V",
      "HVDC Bus Voltage - ولتاژ باس HVDC"
    );
    createAxisAndSeries(
      rev_data,
      true,
      "Iline",
      "A",
      "HVDC Bus Current - جریان باس HVDC"
    );

    // console.log(rev_data , "is rev_data")
    cursor.snapToSeries = series_list;

    // Make stuff animate on load
    // https://www.amcharts.com/docs/v5/concepts/animations/
    chart.appear(400, 100);

    // chart._logo.dispose();

    // Generates random data, quite different range
    function generateChartData(values, type) {
      // console.log(values, "is values");
      if (type === "Pline") {
        const x = values.map((value) => ({
          value: Math.round((value.Iline * value.Vline) / 10000),
          date: (value.date).getTime(),
        }));
        return x?.reverse();
      } else if (type === "Iline") {
        const x = values.map((value) => {
          return {
            value: Math.round((value.Iline / 1000) * 100) / 100,
            date: (value.date).getTime(),
          };
        });
        return x?.reverse();
      } else if (type === "Vline") {
        const x = values.map((value) => ({
          value: Math.round((value.Vline / 100) * 10) ,
          date: (value.date).getTime(),
        }));
        return x?.reverse();
      } 
    }
    let legend = chart.children.push(
      am5.Legend.new(root, {
        useDefaultMarker: true,
      })
    );

    legend.markers.template.setup = function (marker) {
      let check = am5.Graphics.new(root, {
        fill: am5.color(0x000000),
        fillOpacity: 1,
        width: 20,
        height: 20,
        layer: 50,
        svgPath:
          "M15.75 2.527c-.61-.468-1.46-.328-1.902.32l-6.325 9.255L4.04 8.328a1.3 1.3 0 0 0-1.922-.062 1.505 1.505 0 0 0-.062 2.043s4.234 4.695 4.843 5.168c.61.468 1.457.328 1.903-.32L16.05 4.55c.445-.653.308-1.555-.301-2.024Zm0 0",
      });

      check.states.create("disabled", {
        fillOpacity: 0,
      });

      marker.children.push(check);
    };

    
    legend.data.setAll(chart.series.values);

    chart.series.getIndex(1).hide();
    chart.series.getIndex(2).hide();

    return () => root.dispose();
  });

  return (
    <div>
      {loading ? (
        <div className="animated fadeIn">
          <Loader />
          <p className="text-center">در حال بارگذاری...</p>
        </div>
      ) : (
        ""
      )}
      <div
        id="DailyChart"
        style={{
          minWidth: "100%",
          height: "400px",
          direction: "ltr",
          display: loading ? "none" : "block",
        }}
      ></div>
    </div>
  );
}
export default React.memo(DailyChart);
